import { z } from "zod";
const firstPartyIconPath = /^\/(?!\/)[a-zA-Z0-9][a-zA-Z0-9._/-]*$/u;
function isSafeFirstPartyPath(value) {
    return firstPartyIconPath.test(value) && value
        .slice(1)
        .split("/")
        .every((segment) => segment !== "" && segment !== "." && segment !== "..");
}
function isHttpsUrl(value) {
    try {
        const url = new URL(value);
        return url.protocol === "https:" && url.hostname.length > 0;
    }
    catch {
        return false;
    }
}
export const canonicalPluginIconUrlSchema = z.string().trim().min(1).refine((value) => isSafeFirstPartyPath(value) || isHttpsUrl(value), "Canonical plugin iconUrl must be a first-party path or HTTPS URL.");
export function assertCanonicalPluginIconUrls(document) {
    for (const plugin of document.plugins) {
        if (!plugin.enabled)
            continue;
        const result = canonicalPluginIconUrlSchema.safeParse(plugin.branding?.iconUrl);
        if (!result.success) {
            throw new Error(`Canonical plugin '${plugin.slug}' requires a valid branding.iconUrl.`);
        }
    }
}
